const footer = {
  NEWSLETTER_LINK: 'Tilaa uutiskirjeemme!',
  FOLLOW_LABEL: 'Seuraa meitä',
  TERMS_OF_SERVICE: 'Käyttöehdot'
}

export default footer
